import { DropdownContextProvider } from '@app/components/various/Dropdown/context/DropdownContext';
import { cn } from '@app/utils/cn';
import { useOffsetWidth } from '@app/utils/hooks/useOffsetWidth';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { OrderActions } from './OrderActions';
import { OrderOptions } from './OrderOptions';
import { OrderSummary } from './OrderSummary';

interface Props {
  className?: string;
  location: 'products' | 'selection' | 'page';
  orderId: string | undefined;
}

export const OrderBottomBar = ({ className, location, orderId }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const width = useOffsetWidth(ref);

  return (
    <div className={cn('pointer-events-none sticky bottom-4 z-pdm order-2 mt-auto px-4 sm:z-bottomBar lg:px-8', className)}>
      <div
        ref={ref}
        className="pointer-events-auto mx-auto flex w-full max-w-screen-xl items-center justify-between gap-3 rounded-large border border-white bg-neutral-96/85 p-3 shadow-1 backdrop-blur sm:pl-8 xs:gap-4"
      >
        <DropdownContextProvider placement="right-start">
          <OrderOptions />
        </DropdownContextProvider>
        <OrderSummary parentWidth={width} />
        <CSSTransition
          in={width > 0}
          timeout={150}
          unmountOnExit
          classNames={{
            enter: 'opacity-0',
            enterActive: '!opacity-100 transition-opacity',
            exit: 'opacity-100',
            exitActive: '!opacity-0 transition-opacity',
          }}
        >
          <OrderActions location={location} parentWidth={width} orderId={orderId} />
        </CSSTransition>
      </div>
    </div>
  );
};
